import React, { useEffect, useState } from "react";
import apple from "../assets/images/apple_small.png";
import google from "../assets/images/google_small.png";
import pod from "../assets/images/podbean_small.png";
import spotify_small from "../assets/images/sportify_small.png";
import amazon from "../assets/images/amazon_small.png";
import youtube from "../assets/images/youtube_small.png";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Play from "../assets/images/play.png";
import Subscribe from "../components/Subscribe";
import {
  collection,
  onSnapshot,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase";
import { MetaTags } from "react-meta-tags";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const PodcastPage = ({ featured, metaData }) => {
  const [data, setData] = useState([]);
  const [tags, setTags] = useState([]);
  const [selected, setSelected] = useState("All");
  const [pagedata, setPageData] = useState();
  const [active, setActive] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  // prod
  const id = "XvIKnYXnCJQ161PRXBqI";

  // dev
  // const id = "8D87Ecn7wEiCWeZwmeHo";

  useEffect(() => {
    setDataLoading(true);
    setActive("Podcasts");
    id && getPageDataFromDB();
  }, [id]);
  const getPageDataFromDB = async () => {
    const docRef = doc(db, "PodcastDetails", id);
    const snapshot = await getDoc(docRef);
    if (snapshot.exists()) {
      setPageData({ ...snapshot.data() });
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (dataLoading) {
      const hiddenElements = document.querySelectorAll(".hiddenx");
      hiddenElements.forEach((item) => {
        item.style.opacity = "0";
      });
    } else {
      const hiddenElements = document.querySelectorAll(".hiddenx");
      hiddenElements.forEach((item) => {
        item.style.opacity = "1";
        item.classList.add("showx");
      });
    }
    // const getData = async (e) => {
    //   let topList = [];
    //   let tags = [];
    //   const Podcasts = query(
    //     collection(db, "Podcasts"),
    //     orderBy("date", "desc")
    //   );
    //   const querySnapshot = await getDocs(Podcasts);
    //   querySnapshot.forEach((doc) => {
    //     topList.push({ id: doc.id, ...doc.data() });
    //     tags.push(doc.data().category);
    //   });
    //   const uniqueTags = [...new Set(tags)];

    //   setData(topList);
    //   setSelected(uniqueTags[0]);
    //   setTags(uniqueTags);
    // };
    // getData();

    const getData = async (e) => {
      let topList = [];
      let tags = [];
      const Podcasts = query(
        collection(db, "Podcasts"),
        orderBy("date", "desc")
      );
      const querySnapshot = await getDocs(Podcasts);
      querySnapshot.forEach((doc) => {
        topList.push({ id: doc.id, ...doc.data() });
        tags.push(doc.data().category);
      });
      const uniqueTags = [...new Set(tags)];

      setData(topList);
      //  setSelected(uniqueTags[0]);
      setTags(uniqueTags);
    };
    getData();
  }, []);

  const handleTagSelect = async (e) => {
    const targetText = e.target.innerText;
    // e.target.classList.add("active");
    setSelected(targetText);
    const loopTags = document.querySelectorAll(".tags");
    for (let i = 0; i < loopTags.length; i++) {
      loopTags[i].classList.remove("clicked");
      console.log(loopTags[i]);
      if (loopTags[i].innerText === targetText) {
        loopTags[i].classList.add("clicked");
      }
    }

    const collectionRef = collection(db, "Podcasts");

    if (targetText === "All") {
      const topQuerry = query(collectionRef, orderBy("timestamp", "desc"));
      onSnapshot(
        topQuerry,
        (snapshot) => {
          let topList = [];
          snapshot.docs.forEach((doc) => {
            topList.push({ id: doc.id, ...doc.data() });
            setData(topList);
          });
        },
        (error) => {
          console.log(error);
        }
      );
      console.log("All");
    } else {
      const topQuerry = query(
        collectionRef,
        where("category", "==", targetText),
        orderBy("timestamp", "desc")
      );
      onSnapshot(
        topQuerry,
        (snapshot) => {
          let topList = [];
          snapshot.docs.forEach((doc) => {
            topList.push({ id: doc.id, ...doc.data() });
            setData(topList);
          });
        },
        (error) => {
          console.log(error);
        }
      );
    }
  };
  // push to top page after loading
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // if (loading) {
  //   return <Skeleton />;
  // }
  return (
    <>
      <Helmet>
        <title>{metaData?.title + " - Podcasts"} </title>
        <meta name="description" content={metaData?.description} />
        <meta property="og:title" content={metaData?.title + "- Podcasts"} />
        <meta property="og:description" content={metaData?.description} />
        <meta property="og:image" content={metaData?.imageUrl} />
        <link rel="canonical" to={window.location.to} />
        <meta property="og:locale" content="en_GB" />
        <meta property="og:site_name" content={metaData?.title} />
        <meta property="og:url" content={window.location.to} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaData?.title + "- Podcasts"} />
        <meta name="twitter:description" content={metaData?.description} />
        <meta name="twitter:image" content={metaData?.imageUrl} />
      </Helmet>
      <Header active={active} />
      <div className="heroP">
        <div className="wrapper">
          <br />

          <img
            className="hide-large"
            style={{ position: "absolute", top: "80px", width: "93%" }}
            src="https://firebasestorage.googleapis.com/v0/b/wiftz-podcasts.appspot.com/o/bg.png?alt=media&token=361ef195-bb96-479b-819f-9750d056bea9"
          />
          <div className="hide-small pt-200"></div>
          <div className="hide-large pt-80"></div>
          <div className="hero-contentP ">
            <h2 className="hiddenx hidden">{pagedata?.PodcastheadLine}</h2>
            <p className="text-light hiddenx hidden">
              {pagedata?.PodcastsubHeading}
            </p>
          </div>
        </div>
      </div>
      <div className="wrapper custom-position">
        <div className="featured-high" style={{ backgroundColor: "#0D0E18" }}>
          <div className=" latest-podcast  pt-20">
            <div className="wrapper ">
              <div className="latest-container">
                <h2>Latest Podcast</h2>
                <p className="text-light">{pagedata?.PodcastsubHeadlineText}</p>
              </div>
              <hr style={{ border: "1px solid #404253" }} />
              <div className="row pt-50" style={{ margin: "0" }}>
                {featured.map((item) => (
                  <>
                    <div className="col-md-4 col-sm-12">
                      <Link to={"/podcast/" + item.url}>
                        <img
                          className="thumbnail"
                          src={item?.FeatureImage}
                          alt="podcast"
                        />
                      </Link>
                    </div>
                    <div className="col-md-8 col-sm-12 p-10">
                      <div className="">
                        <Link className="nol" to={`/podcast/${item.url}`}>
                          <h3 className="podcast-title text-light">
                            {item?.title}
                          </h3>{" "}
                        </Link>
                        <p className="podcast-desc">
                          <div
                            className=""
                            dangerouslySetInnerHTML={{
                              __html: item?.shortDescription.substring(0, 210),
                            }}
                          />
                        </p>

                        <button className=" secondary featured">
                          Listen or watch on
                        </button>
                        <br />

                        <div className="medias row">
                          {item.sportify ? (
                            <div className="col-md-4 col-sm-6 sm-thumbnail">
                              <a href={item.sportify}>
                                <img className="" src={spotify_small} alt="" />
                              </a>
                            </div>
                          ) : (
                            ""
                          )}
                          {item.apple ? (
                            <div className="col-md-4 col-sm-6 sm-thumbnail">
                              <a href={item.apple}>
                                <img className="" src={apple} alt="" />
                              </a>
                            </div>
                          ) : (
                            ""
                          )}
                          {item.amazon ? (
                            <div className="col-md-4 col-sm-6 sm-thumbnail">
                              <a href={item.amazon}>
                                <img className="" src={amazon} alt="" />
                              </a>
                            </div>
                          ) : (
                            ""
                          )}
                          {item.google ? (
                            <div className="col-md-4 col-sm-6 sm-thumbnail">
                              <a href={item.google}>
                                <img className="" src={google} alt="" />
                              </a>
                            </div>
                          ) : (
                            ""
                          )}
                          {item.pod ? (
                            <div className="col-md-4 col-sm-6 sm-thumbnail">
                              <a href={item.pod}>
                                <img className="" src={pod} alt="" />
                              </a>
                            </div>
                          ) : (
                            ""
                          )}
                          {item.youtube ? (
                            <div className="col-md-4 col-sm-6 sm-thumbnail">
                              <a href={item.youtube}>
                                <img className="" src={youtube} alt="" />
                              </a>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <br />
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
        <section className=" latest-podcast ">
          <div className="pt-90">
            <div className="latest-container">
              <h2>
                {pagedata?.PodcastsubHeadLine} |&nbsp;
                <span style={{ color: "#585AA8" }}>{selected}</span>
              </h2>
              <p className="text-light">{pagedata?.PodcastsubText2}</p>
            </div>
            <div className="tag  scroll-h">
              <button className="tags clicked" onClick={handleTagSelect}>
                All
              </button>
              {tags?.map((tag, index) => (
                <button className="tags" key={index} onClick={handleTagSelect}>
                  {tag}
                </button>
              ))}
            </div>
            <div className="row pt-10 container">
              {data?.map((data, index) => (
                <Link
                  className="nol x-4 col-sm-12  pod-content"
                  to={`/podcast/${data.url}`}
                  key={index}
                >
                  <div className="image-container">
                    <span className="green-overlay"></span>

                    <img
                      src={data.FeatureImage}
                      alt={data.title}
                      className="pod-content-img"
                    />
                  </div>
                  <h3 className="title ">{data?.title}</h3>
                  <p className="podcast-desc">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data?.shortDescription.substring(0, 210),
                      }}
                    />
                  </p>
                  <img className="play-ico" src={Play} alt="" />
                  <p className="ptx-10">Listen to this podcast</p>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </div>
      <div style={{ padding: "20px" }}>
        <Subscribe />
      </div>
      <Footer />
    </>
  );
};

export default PodcastPage;
